import { Box, Typography } from '@mui/material';
import React from 'react';
import { useSocketInstanceContext } from 'context/socketInstanceContext';

interface IChatHintButton {
   text: string;
   icon: React.ReactElement;
   onClick: () => void;
}

const ChatHintButton: React.FC<IChatHintButton> = ({ icon, text, onClick }) => {
   return (
      <Box
         onClick={onClick}
         sx={{
            cursor: 'pointer',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 'fit-content',
            flexDirection: 'row',
            columnGap: '8px',
            py: 1,
            px: 1.5,
            borderRadius: '8px',
            border: '1px solid #00000010',
         }}
      >
         {icon}
         <Box>
            <Typography sx={{ fontSize: '14px', lineHeight: '17px', color: '#333333', fontWeight: 600 }}>
               {text}
            </Typography>
         </Box>
      </Box>
   );
};

export default ChatHintButton;
